const INITIAL_STATE = {
  data: {},
  errors: {},
    
}
const updateMesssage = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'UPDATE_MESSAGE':
    return { ...INITIAL_STATE, data: action.data }
  case 'UPDATE_MESSAGE_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
    
export default updateMesssage;